<template>
  <div class="reservation-history">
    <h1>Historial de Reservaciones</h1>

    <div v-if="scannedReservations.length">
      <h2>Reservaciones Escaneadas</h2>
      <ul>
        <li v-for="reservation in scannedReservations" :key="reservation.id">
          {{ reservation.name }} - {{ reservation.date }} {{ formatTime(reservation.time) }}
          <p><strong>Mesa:</strong> {{ reservation.tableNumber || 'N/A' }}</p>
          <p><strong>Estado:</strong> {{ reservation.status }}</p>
        </li>
      </ul>
    </div>
    <div v-else>
      <p>No hay reservaciones escaneadas disponibles.</p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/init';

export default {
  name: 'ReservationHistoryView',
  setup() {
    const scannedReservations = ref([]);

    // Formato de hora de 12 horas
    const formatTime = (time) => {
      const [hour, minute] = time.split(':');
      const date = new Date();
      date.setHours(hour, minute);
      const options = { hour: '2-digit', minute: '2-digit', hour12: true };
      return new Intl.DateTimeFormat('es-ES', options).format(date);
    };

    onMounted(() => {
      const q = query(collection(db, 'reservations'), where('status', '==', 'used'));
      onSnapshot(q, (snapshot) => {
        scannedReservations.value = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      });
    });

    return {
      scannedReservations,
      formatTime
    };
  }
};
</script>

<style scoped>
.reservation-history {
  padding: 20px;
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

h2 {
  font-size: 20px;
  margin-bottom: 10px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 8px;
}

p {
  margin: 0;
  font-size: 14px;
}

strong {
  font-weight: bold;
}
</style>
